import { render, staticRenderFns } from "./TsPanelHeader.vue?vue&type=template&id=66a268d1"
import script from "./TsPanelHeader.vue?vue&type=script&lang=ts"
export * from "./TsPanelHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports